import { SelectButton } from "primereact/selectbutton";
import styled from "styled-components";

export const StyledOrderTypeSwitch = styled(SelectButton)`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.75rem;

  width: 100%;
  padding: 0;
  border: none;
  background: transparent;

  .p-button {
    flex: 0 0 auto;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    border: 1px solid var(--brand-gray-200);
    border-radius: 10px;
    background: var(--brand-gray-50);
    color: var(--brand-gray-600);

    font-size: 0.875rem;
    font-weight: var(--font-weight-semibold);
    line-height: 1.25;
    padding: 0.75rem 1rem;
  }

  .p-button:first-of-type,
  .p-button:last-of-type,
  .p-button:not(:first-of-type):not(:last-of-type) {
    border-radius: 10px;
  }

  .p-button:not(:last-child) {
    border-right: 1px solid var(--brand-gray-200);
  }

  .p-button .p-button-label {
    display: inline-flex;
    align-items: center;
    gap: 0.625rem;
  }

  .p-button .p-button-label::before {
    content: "";
    flex-shrink: 0;

    width: 1.25rem;
    height: 1.25rem;
    border-radius: 6px;
    border: 1px solid var(--brand-gray-200);
    background: var(--brand-white);
  }

  .p-button:not(.p-disabled):not(.p-highlight):hover {
    border-color: var(--brand-gray-400);
    background: var(--brand-gray-50);
    color: var(--brand-gray-700);
  }

  .p-button.p-highlight,
  .p-button.p-highlight:hover,
  .p-button.p-highlight:first-of-type,
  .p-button.p-highlight:last-of-type,
  .p-button.p-highlight:not(:first-of-type):not(:last-of-type) {
    border: 1px solid var(--brand-purple-500);
    border-radius: 10px;
    background: color-mix(
      in srgb,
      var(--brand-purple-500) 6%,
      var(--brand-white)
    );
    color: var(--brand-black);
    box-shadow: 0 0 0 3px
      color-mix(in srgb, var(--brand-purple-500) 12%, transparent);
  }

  .p-button.p-highlight .p-button-label::before {
    content: "\\e909";
    font-family: "primeicons";
    font-size: 0.75rem;
    line-height: 1;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    color: var(--brand-white);
    background: var(--brand-purple-600);
    border-color: var(--brand-purple-600);
  }

  &.p-disabled {
    opacity: 0.6;
  }
`;
